import { listenLogout } from '../../auth';

export const saveViewState = <StorageKey extends string = string>(
  storageKey: StorageKey,
  state: Record<PropertyKey, any>,
) => {
  storage.setItem(getViewStateKey(storageKey), JSON.stringify(state));
};

export const loadViewState = <StorageKey extends string = string>(
  storageKey: StorageKey,
) => {
  const savedStateRaw = storage.getItem(getViewStateKey(storageKey));

  if (!savedStateRaw) {
    return;
  }

  try {
    return JSON.parse(savedStateRaw);
  } catch (error) {
    console.error('Failed to parse directory state from sessionStorage', error);
  }
};

export const hasViewState = <StorageKey extends string = string>(
  storageKey: StorageKey,
) => Boolean(storage.getItem(getViewStateKey(storageKey)));

const storage = window.localStorage;

type ViewStateKeyPrefix = 'viewState';
type ViewStateKey = `${ViewStateKeyPrefix}:${string}`;

const getViewStateKey = <K extends string>(key: K) =>
  `viewState:${key}` as const;

const isViewStateKey = (key: unknown): key is ViewStateKey =>
  typeof key === 'string' && key.startsWith('viewState:');

listenLogout(() => {
  for (const key of Object.keys(localStorage)) {
    if (isViewStateKey(key)) {
      storage.removeItem(key);
    }
  }
});
